// Input / Textarea / Select genérico — portado de Admin One

const base = [
  "w-full rounded-lg border px-3 py-2 text-sm",
  "text-gray-800 dark:text-white",
  "bg-white dark:bg-slate-800",
  "border-gray-300 dark:border-slate-600",
  "placeholder:text-gray-400 dark:placeholder:text-gray-500",
  "focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
  "disabled:opacity-50 disabled:cursor-not-allowed",
  "transition-colors",
].join(" ");

export default function FormControl({
  type = "text",
  value,
  onChange,
  onBlur,
  placeholder,
  disabled = false,
  readOnly = false,
  rows = 3,
  options = [],      // [{ value, label }] para <select>
  className = "",
  name,
  id,
  autoComplete,
  min,
  max,
  step,
}) {
  if (type === "textarea") {
    return (
      <textarea
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        rows={rows}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        className={[base, className].join(" ")}
      />
    );
  }

  if (type === "select") {
    return (
      <select
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        className={[base, className].join(" ")}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    );
  }

  return (
    <input
      id={id}
      name={name}
      type={type}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      disabled={disabled}
      readOnly={readOnly}
      autoComplete={autoComplete}
      min={min}
      max={max}
      step={step}
      className={[base, className].join(" ")}
    />
  );
}
